// src/components/ModalAgregarMetodoPago.jsx
import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarMetodoPago = ({ show, onClose, onMetodoAgregado }) => {
    const [nuevoMetodo, setNuevoMetodo] = useState({ nombre_metodo: "" });

    // Función para manejar el envío del formulario
    const handleAgregarMetodo = async (e) => {
        e.preventDefault();
        if (nuevoMetodo.nombre_metodo.trim() === "") {
            alert("El nombre del método de pago es requerido.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "metodos_pago",
                nombre_metodo: nuevoMetodo.nombre_metodo
            });

            onMetodoAgregado(); // Actualiza la lista de métodos de pago al agregar el método
            onClose(); // Cierra el modal
            setNuevoMetodo({ nombre_metodo: "" }); // Resetea el formulario
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Método de Pago</h2>
                <form onSubmit={handleAgregarMetodo}>
                    <input
                        type="text"
                        value={nuevoMetodo.nombre_metodo}
                        onChange={(e) => setNuevoMetodo({ ...nuevoMetodo, nombre_metodo: e.target.value })}
                        placeholder="Nombre del método de pago"
                        className="border rounded-lg p-2 mb-4 w-full"
                        maxLength={20}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarMetodoPago;
